import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { RoleEnum } from '../../constants/role.constant';
import { TokenModel } from '../../models/auth.model';
import { LocalStorageService } from '../storages/local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class RolesService {
    private userRoles!: RoleEnum[];

    constructor(private localStorageService: LocalStorageService) {
        this.getUserRoles();
    }

    isCorporateInvestor(): boolean {
        const nonIndividualRoles = [
            RoleEnum.VerifiedCorporateInvestor,
            RoleEnum.UnverifiedCorporateInvestor,
            RoleEnum.RestrictedCorporateInvestor,
        ];

        return this.userRoles.map((role) => nonIndividualRoles.includes(role)).includes(true);
    }

    isIssuer(): boolean {
        const issuerRoles = [RoleEnum.VerifiedIssuer, RoleEnum.UnverifiedIssuer, RoleEnum.RestrictedIssuer];

        return this.userRoles.map((role) => issuerRoles.includes(role)).includes(true);
    }

    isIndividualInvestor(): boolean {
        const individualRoles = [
            RoleEnum.VerifiedIndividualInvestor,
            RoleEnum.UnverifiedIndividualInvestor,
            RoleEnum.RestrictedIndividualInvestor,
        ];

        return this.userRoles.map((role) => individualRoles.includes(role)).includes(true);
    }

    private getUserRoles(): void {
        const user = this.localStorageService.getLoginUser();

        if (!user) {
            return;
        }

        const jwtData = jwtDecode<TokenModel>(user.accessToken);

        let permissions: any = jwtData.roleEnums;

        if (typeof jwtData.roleEnums === 'string') {
            permissions = [jwtData.roleEnums];
        }

        this.userRoles = permissions.map((permission: any) => +permission);
    }
}
